import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { enforceHttps } from './utils/httpsEnforcer'
import { ThemeProvider } from './providers/ThemeProvider'
import { initPreload } from './utils/preloadData'

// Forza HTTPS in produzione
enforceHttps();

// Inizializza prefetching dati
initPreload();

createRoot(document.getElementById("root")!).render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
